import { Typography } from "@mui/material";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import { contactsDetails } from "../../data/ContactsData";

import "./HeaderContactDetails.css";

export default function HeaderContactDetails() {
  return (
    <div className="contact-header">
      <div className="contact-left">
        <div className="container">
          <div className="contact-item">
            <MailOutlinedIcon fontSize="small" />
            <Typography variant="body2" className="contact-text">
              {contactsDetails.email}
            </Typography>
          </div>

          <div className="contact-item">
            <LocalPhoneOutlinedIcon fontSize="small" />
            <Typography variant="body2" className="contact-text">
              {contactsDetails.phone}
            </Typography>
          </div>

          <div className="contact-item">
            <LocationOnOutlinedIcon fontSize="small" />
            <Typography variant="body2" className="contact-text">
              <a
                href={contactsDetails.locationLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit", textDecoration: "none" }}
              >
                {contactsDetails.location}
              </a>
            </Typography>
          </div>
        </div>
      </div>

      <div className="contact-right">
        <FacebookIcon className="social-icon" />
        <XIcon className="social-icon" />
        <InstagramIcon className="social-icon" />
      </div>
    </div>
  );
}
